module.exports = __webpack_public_path__ + "img/img-full-copy@2x.8ba5edf1.jpg";